import React, { Fragment } from 'react'
import { ComponentCoreAffiliateProgram, Maybe } from '@/gql/generated/graphql'
import { Enum_Componentcorebutton_Color } from '@/gql/generated/graphql'
import ResponsiveImage from './ResponsiveImage'

type Props = {
  card: Maybe<ComponentCoreAffiliateProgram>
}

export default function AffiliateProgram(props: Props) {
  if (!props) return null
  return (
    <Fragment>
      <div className="affiliate-item mb-10 w-full rounded-md p-6 transition duration-300 hover:bg-white md:mb-0 md:w-auto md:min-w-[465px] md:p-16">
        <ResponsiveImage image={props.card?.image} className='mb-5 h-[76px] w-[76px]' />
        <h4 className="text-base text-title-color">{props.card?.title}</h4>
        <h3 className="mb-5 text-4xl">{props.card?.subtitle}</h3>
        <div className="button-wrap flex flex-wrap items-center justify-between gap-x-5">
          {props.card?.buttons?.map((button, index) => (
            <div key={index}>
            {button?.color === Enum_Componentcorebutton_Color.White ?
                <a href={button?.href ?? '#'} className="arrow-btn mb-5 pr-6 text-base font-semibold text-[#8264EB] hover:underline md:mb-0">{button.label}</a>
                :
                button?.color === Enum_Componentcorebutton_Color.Purple &&
                <a href={button?.href ?? '#'} className="fill-btn mb-5 rounded-full bg-[#8264EB] px-5 py-3 text-base font-semibold text-white hover:bg-[#6239F7] md:mb-0 md:px-10">{button.label}</a>
            }
            </div>
          ))}
        </div>
      </div>
    </Fragment>
  )
}
